import { Booking, } from "../../../../requests-module/src";
import { PackageEnum } from "../packageHelpers";

function checkIsPackageTrain(booking: Booking): boolean {
    if (booking?.packageCode?.includes(PackageEnum.PFTT)
        || booking?.packageCode?.includes(PackageEnum.PFTTF)
        || booking?.packageCode?.includes(PackageEnum.PFTTNL)
        || booking?.packageCode?.includes(PackageEnum.HTT)
        || booking?.packageCode?.includes(PackageEnum.HTTF)
        || booking?.packageCode?.includes(PackageEnum.PFPTTF)
        || booking?.packageCode?.includes(PackageEnum.PFPTTNL)
        || booking?.packageCode === PackageEnum.TNE
        || booking?.packageCode?.includes('WTNE')) {
        return true
    }


    return false
}

export default checkIsPackageTrain